import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import translate from "react-i18next/dist/commonjs/translate";
import PageTitle from "../common/text/PageTitle";
import Filter from "../common/Filter";
import Loading from "../common/Loading";
import IncidentRow from "./incidentRow";
import IncidentsSearch from "./incidentsSearch";
import ErrorMessage from "./errorMessage";
import IncidentsBecomePlusCustomer from "./IncidentsBecomePlusCustomer";
import * as actions from "./incidentActions";
import {
  getPriorityFilter,
  getStatusFilter,
  getVisibileIncidents,
  getIncidentsHasErrors
} from "./incidentSelector";

class IncidentsPage extends React.Component {
  state = {
    incidentParamsId: null,
    status: null
  };
  constructor(props) {
    super(props);
    this.handlePriorityFilterClick = this.handlePriorityFilterClick.bind(this);
    this.handleStatusFilterClick = this.handleStatusFilterClick.bind(this);
    this.handleSortDate = this.handleSortDate.bind(this);
    this.handleSortID = this.handleSortID.bind(this);
    this.handleSortPriority = this.handleSortPriority.bind(this);
    this.handleSortStatus = this.handleSortStatus.bind(this);
    this.handleSortAction = this.handleSortAction.bind(this);
    this.handleSortSubject = this.handleSortSubject.bind(this);
    this.onReload = this.onReload.bind(this);
    this.addResolutionProposalAction = this.addResolutionProposalAction.bind(this);
    this.updateCommentType = this.updateCommentType.bind(this);
    this.addComment = this.addComment.bind(this);
    this.handleSearchFilterClick = this.handleSearchFilterClick.bind(this);
  }

  componentDidMount() {
    if (this.props.customerInformation.plusCustomer) {
      this.props.actions.loadOpenIncident();
      this.setState({
        incidentParamsId: this.props.params.id,
        status: this.props.params.status
      }, () => {
        if (this.state.status != null) {
          this.props.actions.clearIncidentStatus();
          this.props.actions.filterIncidentStatus(this.state.status);
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.isOpenIncidentEmpty === true){
      this.props.actions.loadCloseIncident();
    }    
  }

  handlePriorityFilterClick(value) {
    this.setState({ incidentParamsId: null });
    this.props.actions.filterIncidentPriority(value);
  }

  handleStatusFilterClick(value) {
    this.setState({ incidentParamsId: null });
    if (this.props.statusFilter.some(item => item.key === "Closed" && item.isSelected === false && value === "Closed")) {
      this.props.actions.loadCloseIncident();
    }
    this.props.actions.filterIncidentStatus(value);

  }

  handleSearchFilterClick(value) {
    this.props.actions.filterIncidentSearch(value);
  }

  handleSort(sortBy, sortFunc) {
    const incidentSorting = this.props.incidentSorting;
    const isSorted = incidentSorting.by === sortBy;

    let direction;
    if (isSorted) {
      direction = incidentSorting.direction === "desc" ? "asc" : "desc";
    } else {
      direction = "asc";
    }

    this.props.actions.sortIncident({
      by: sortBy,
      func: sortFunc,
      direction
    });
  }

  handleSortDate() {
    this.handleSort("Date");
  }
  handleSortSubject() {
    this.handleSort("Subject", state => state.Subject.toLowerCase());
  }
  handleSortID() {
    this.handleSort("Id");
  }
  handleSortPriority() {
    this.handleSort("Priority");
  }
  handleSortStatus() {
    this.handleSort("Status");
  }
  handleSortAction() {
    this.handleSort("LatestComment.CommentType");
  }

  onReload() {
    this.props.actions.loadOpenIncident();
  }

  addResolutionProposalAction(incidentId, commentId, action, commentType) {
    this.props.actions.addResolutionProposalAction(incidentId, commentId, action, commentType);
  }

  updateCommentType(incidentId, commentId, action, commentType) {
    this.props.actions.updateCommentType(incidentId, commentId, action, commentType);
  }
  addComment(incidentId, comment, commentType) {
    this.props.actions.addComment(incidentId, comment, commentType);
  }

  render() {
    const incidents = this.props.visibileIncidents;
    const { hasErrors, isLoading, t, customerInformation } = this.props;
    if (!customerInformation.plusCustomer) {
      return <IncidentsBecomePlusCustomer />;
    }

    if (isLoading) {
      return <Loading title={t("incidentsPageTitle")} />;
    }

    if (hasErrors) {
      return (
        <ErrorMessage
          title={t("incidentsPageTitle")}
          onReload={this.onReload}
        />
      );
    }

    return (
      <div className="my-nodes-page">
        <section className="main-content">
          <PageTitle text={t("incidentsPageTitle")} />
          <div className="container">
            <div className="filter">
              <div>
                <i className="fa fa-filter" /> {t("incidentsFilterLabelStatus")}
                {this.props.statusFilter.map((filter, id) => (
                  <Filter
                    key={id}
                    value={filter.key}
                    handleClick={this.handleStatusFilterClick}
                    isSelected={filter.isSelected}
                  />
                ))}
              </div>
              <div>
                <i className="fa fa-filter" />
                {t("incidentsFilterLabelPriority")}
                {this.props.priorityFilter.map((filter, id) => (
                  <Filter
                    key={id}
                    value={filter.key}
                    handleClick={this.handlePriorityFilterClick}
                    isSelected={filter.isSelected}
                  />
                ))}
              </div>
              <div>
                {t("incidentsFilterLabelSearch")}
                <IncidentsSearch handleSearchFilterClick={this.handleSearchFilterClick} />
              </div>
            </div>
            <table className="table table-responsive table-hover table-sortable table-ui">
              <thead>
                <tr>
                  <th />
                  <th onClick={this.handleSortDate}>
                    {t("incidentsTableThDate")}{" "}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortSubject}>
                    {t("incidentsTableThSubject")}{" "}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortID}>
                    {t("incidentsTableThID")}{" "}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortPriority}>
                    {t("incidentsTableThPriority")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortStatus}>
                    {t("incidentsTableThStatus")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortAction}>
                    {t("incidentsTableThAction")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th />
                </tr>
              </thead>
              {incidents.map(incident => {
                return (
                  <IncidentRow
                    key={incident.id}
                    id={incident.id}
                    date={incident.date}
                    priority={incident.priority}
                    subject={incident.subject}
                    status={incident.status}
                    latestAction={incident.actionTaken}
                    comments={incident.comments}
                    latestComment={incident.latestComment}
                    selectedIncident={this.state.incidentParamsId}
                    addResolutionProposalAction={this.addResolutionProposalAction}
                    updateCommentType={this.updateCommentType}
                    addComment={this.addComment}
                  />
                );
              })}
            </table>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    logIncident: state.logIncident,
    incidentSorting: state.incidentSorting,
    customerInformation: state.customerInformation,
    priorityFilter: getPriorityFilter(state),
    statusFilter: getStatusFilter(state),
    visibileIncidents: getVisibileIncidents(state),
    hasErrors: getIncidentsHasErrors(state),
    isLoading: state.incidentIsLoading,
    isOpenIncidentEmpty: state.isOpenIncidentEmpty
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

IncidentsPage.propTypes = {
  childPage: PropTypes.object,
  customerInformation: PropTypes.object.isRequired,
  logIncident: PropTypes.array.isRequired,
  incidentSorting: PropTypes.object.isRequired,
  priorityFilter: PropTypes.array.isRequired,
  statusFilter: PropTypes.array.isRequired,
  visibileIncidents: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOpenIncidentEmpty: PropTypes.bool.isRequired
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IncidentsPage)
);



// WEBPACK FOOTER //
// ./src/incidents/Incidents.js